import { render, staticRenderFns } from "./detail-dzz.vue?vue&type=template&id=2d39e511&scoped=true&"
import script from "./detail-dzz.vue?vue&type=script&lang=js&"
export * from "./detail-dzz.vue?vue&type=script&lang=js&"
import style0 from "./detail-dzz.vue?vue&type=style&index=0&id=2d39e511&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d39e511",
  null
  
)

export default component.exports